import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {GENERAL_NEW_TAB, GENERAL_RETURN_TAB} from 'constants/analytics/events/general';

import {sessionStore} from 'libs/storage/storage';

/**
 * Implements unfocus animation for non active tab in the browser
 * singleton
 */
export class FlickerAnimation {
    /**
     * To store timer id for change title
     */
    tr?: number;

    /**
     * To store timer id for restore title
     */
    tc?: number;

    /**
     * Flag to store focus on the window
     */
    unFocused?: number;

    /**
     * To store original title
     */
    title?: string;

    /**
     * To store unfocused title
     */
    unFocusedTitle = 'Eyeglasses — Sale';

    /**
     * Instance of the class
     */
    private static instance: FlickerAnimation;

    /**
     * Returns an instance of flicker
     * @returns {FlickerAnimation} instance
     */
    static getInstance(): FlickerAnimation {
        if (!FlickerAnimation.instance) {
            FlickerAnimation.instance = new FlickerAnimation();
        }
        return FlickerAnimation.instance;
    }

    /**
     * Start flicker
     */
    start = () => {
        // Initialization delay for "react-helmet"
        window.addEventListener('load', () => {
            this.unFocused = 0;
            this.title = this.title || document.title;
            window.setInterval(this.checkWindowFocus, 1000);
            this.returnAndNewTabAnalytics();
        });
    };

    /**
     * Used when need to update the initial title
     * @param {string} title - new title
     */
    updateTitle = (title: string) => {
        this.title = title;
    };

    /**
     * Restore title to default and clear intervals
     */
    resetTitle = () => {
        clearTimeout(this.tr);
        clearTimeout(this.tc);
        document.title = this.title!;
    };

    /**
     * Used when need to update the initial unFocusedTitle
     * @param {string} title - new title
     */
    updateUnFocusedTitle = (title: string) => {
        this.unFocusedTitle = title;
    };

    /**
     * Reset unfocused title to defaults
     */
    resetUnFocusedTitle = () => {
        this.unFocusedTitle = 'Eyeglasses — Sale';
    };

    /**
     * Change title to custom
     */
    changeTitle = () => {
        document.title = this.unFocusedTitle;
        this.tr = window.setTimeout(this.resetTitleAnimate, 1000);
    };

    /**
     * Restore title
     */
    resetTitleAnimate = () => {
        document.title = this.title!;
        this.tc = window.setTimeout(this.changeTitle, 1000);
    };

    /**
     * Main function which one check activity on the tab
     */
    checkWindowFocus = () => {
        if (document.hasFocus()) {
            this.unFocused = 0;
            this.resetTitle();
        } else if (this.unFocused !== 1) {
            this.tc = window.setTimeout(this.changeTitle, 500);
            this.unFocused = 1;
        }
    };

    /**
     * handle return and new tab analytics
     * clear itself then all analytics was sent
     */
    returnAndNewTabAnalytics = () => {
        const intervalId = window.setInterval(() => {
            const getNewTabCookie = sessionStore.get(
                'GeneralGeneralBrowserTabNewTab-Opened',
                false,
            );

            if (document.hasFocus() && this.unFocused === 0 && getNewTabCookie) {
                sendDesktopAnalyticsPerSession({event: GENERAL_RETURN_TAB});

                window.clearInterval(intervalId);
            }
            if (!document.hasFocus() && this.unFocused === 1) {
                sendDesktopAnalyticsPerSession({event: GENERAL_NEW_TAB});
            }
        }, 1000);
    };
}
